import { render, staticRenderFns } from "./EditProdInfo.vue?vue&type=template&id=7b97ccb1&scoped=true"
import script from "./EditProdInfo.vue?vue&type=script&lang=js"
export * from "./EditProdInfo.vue?vue&type=script&lang=js"
import style0 from "./EditProdInfo.vue?vue&type=style&index=0&id=7b97ccb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b97ccb1",
  null
  
)

export default component.exports